(() => {
  const publish = (name, payload = {}) => {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...payload });
    } catch (error) {
      return;
    }
  };

  const initialise = (root) => {
    if (root.dataset.modulloReady === 'true') return;
    root.dataset.modulloReady = 'true';

    const language = root.dataset.language || 'it';
    const cards = Array.from(root.querySelectorAll('[data-modullo-card]'));
    const filters = Array.from(root.querySelectorAll('[data-modullo-filter]'));
    const count = root.querySelector('[data-modullo-count]');
    const noResults = root.querySelector('[data-modullo-no-results]');
    const conceptInput = root.querySelector('[data-modullo-concept-input]');
    const form = root.querySelector('[data-modullo-form]');
    const filterReset = root.querySelector('[data-modullo-filter-reset]');
    const componentButtons = Array.from(root.querySelectorAll('[data-modullo-select-component]'));
    const componentCheckboxes = Array.from(root.querySelectorAll('[data-modullo-component-checkbox]'));
    const componentCount = root.querySelector('[data-modullo-component-count]');
    const lightbox = root.querySelector('[data-modullo-lightbox]');
    const lightboxImage = root.querySelector('[data-modullo-lightbox-image]');
    const lightboxCaption = root.querySelector('[data-modullo-lightbox-caption]');

    const applyFilters = () => {
      const current = filters.reduce((values, filter) => {
        values[filter.dataset.modulloFilter] = filter.value;
        return values;
      }, {});
      let visible = 0;

      cards.forEach((card) => {
        const features = (card.dataset.features || '').split(/\s+/).filter(Boolean);
        const categoryMatches = current.category === 'all' || card.dataset.category === current.category;
        const levelsMatch = current.levels === 'all' || card.dataset.levels === current.levels;
        const featureMatches = current.feature === 'all' || features.includes(current.feature);
        const matches = categoryMatches && levelsMatch && featureMatches;
        card.hidden = !matches;
        if (matches) visible += 1;
      });

      if (count) count.textContent = String(visible);
      if (noResults) noResults.hidden = visible !== 0;
    };

    filters.forEach((filter) => {
      filter.addEventListener('change', () => {
        applyFilters();
        publish('ecoflusso_modullo_filter', {
          language,
          filter_name: filter.dataset.modulloFilter,
          filter_value: filter.value,
        });
      });
    });

    if (filterReset) {
      filterReset.addEventListener('click', () => {
        filters.forEach((filter) => {
          filter.value = 'all';
        });
        applyFilters();
        publish('ecoflusso_modullo_filter_reset', { language });
      });
    }

    const updateComponentSelection = () => {
      let selected = 0;
      componentButtons.forEach((button) => {
        const code = button.dataset.modulloSelectComponent || '';
        const checkbox = componentCheckboxes.find((item) => item.dataset.modulloComponentCheckbox === code);
        const isSelected = Boolean(checkbox && checkbox.checked);
        button.setAttribute('aria-pressed', String(isSelected));
        const addLabel = button.querySelector('[data-component-add]');
        const addedLabel = button.querySelector('[data-component-added]');
        if (addLabel) addLabel.hidden = isSelected;
        if (addedLabel) addedLabel.hidden = !isSelected;
        if (isSelected) selected += 1;
      });
      if (componentCount) componentCount.textContent = String(selected);
    };

    componentButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const componentCode = button.dataset.modulloSelectComponent || '';
        const checkbox = componentCheckboxes.find((item) => item.dataset.modulloComponentCheckbox === componentCode);
        if (!checkbox) return;
        checkbox.checked = !checkbox.checked;
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        updateComponentSelection();
        publish('ecoflusso_modullo_component_selected', {
          language,
          component_code: componentCode,
          selected: checkbox.checked,
        });
      });
    });

    componentCheckboxes.forEach((checkbox) => checkbox.addEventListener('change', updateComponentSelection));

    root.querySelectorAll('[data-modullo-select-concept]').forEach((button) => {
      button.addEventListener('click', () => {
        const conceptId = button.dataset.modulloSelectConcept || '';
        if (conceptInput) {
          conceptInput.value = conceptId;
          conceptInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        root.querySelectorAll('[data-modullo-select-concept]').forEach((candidate) => {
          const isSelected = candidate === button;
          candidate.setAttribute('aria-pressed', String(isSelected));
          const selectLabel = candidate.querySelector('[data-concept-select]');
          const selectedLabel = candidate.querySelector('[data-concept-selected]');
          if (selectLabel) selectLabel.hidden = isSelected;
          if (selectedLabel) selectedLabel.hidden = !isSelected;
        });
        publish('ecoflusso_modullo_concept_selected', { language, concept_id: conceptId });
        const target = root.querySelector('#modullo-rfq');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(() => conceptInput && conceptInput.focus({ preventScroll: true }), 550);
      });
    });

    root.querySelectorAll('[data-modullo-image-open]').forEach((button) => {
      button.addEventListener('click', () => {
        const imageUrl = button.dataset.imageUrl || '';
        const imageAlt = button.dataset.imageAlt || '';
        const conceptId = button.dataset.imageConcept || '';
        if (!lightbox || !lightboxImage || !imageUrl || typeof lightbox.showModal !== 'function') {
          if (imageUrl) window.open(imageUrl, '_blank', 'noopener');
          return;
        }
        lightboxImage.src = imageUrl;
        lightboxImage.alt = imageAlt;
        if (lightboxCaption) lightboxCaption.textContent = `${conceptId} · ${imageAlt}`;
        lightbox.showModal();
        publish('ecoflusso_modullo_image_open', { language, concept_id: conceptId });
      });
    });

    const lightboxClose = root.querySelector('[data-modullo-lightbox-close]');
    if (lightbox && lightboxClose) lightboxClose.addEventListener('click', () => lightbox.close());
    if (lightbox) {
      lightbox.addEventListener('click', (event) => {
        if (event.target === lightbox) lightbox.close();
      });
    }

    root.querySelectorAll('[data-modullo-language-switch]').forEach((link) => {
      link.addEventListener('click', () => {
        publish('ecoflusso_modullo_language_switch', {
          from_language: language,
          to_language: link.dataset.modulloLanguageSwitch,
        });
      });
    });

    root.querySelectorAll('[data-modullo-whatsapp]').forEach((link) => {
      link.addEventListener('click', () => publish('ecoflusso_modullo_whatsapp_click', { language }));
    });

    const parameters = new URLSearchParams(window.location.search);
    const populateTrackingFields = () => {
      root.querySelectorAll('[data-modullo-utm]').forEach((input) => {
        const key = input.dataset.modulloUtm;
        input.value = parameters.get(key) || '';
      });

      const productReference = root.querySelector('[data-modullo-product-reference]');
      const variantReference = root.querySelector('[data-modullo-variant-reference]');
      const languageInput = root.querySelector('[name="contact[language]"]');
      const sourcePageInput = root.querySelector('[name="contact[source_page]"]');
      const formVersionInput = root.querySelector('[name="contact[form_version]"]');
      if (productReference) productReference.value = parameters.get('modullo_product') || '';
      if (variantReference) variantReference.value = parameters.get('modullo_variant') || '';
      if (languageInput) languageInput.value = language;
      if (sourcePageInput) sourcePageInput.value = `${window.location.origin}${window.location.pathname}`;
      if (formVersionInput) formVersionInput.value = root.dataset.formVersion || '';

      const referrerInput = root.querySelector('[data-modullo-referrer]');
      if (referrerInput) {
        try {
          referrerInput.value = document.referrer ? new URL(document.referrer).hostname : '';
        } catch (error) {
          referrerInput.value = '';
        }
      }
    };

    populateTrackingFields();

    const success = root.querySelector('[data-modullo-success]');
    if (success) {
      const successKey = `modullo-rfq-success-${language}-${window.location.pathname}`;
      if (window.sessionStorage.getItem(successKey) !== 'true') {
        publish('ecoflusso_modullo_rfq_submit_success', {
          language,
          form_version: root.dataset.formVersion,
        });
        window.sessionStorage.setItem(successKey, 'true');
      }
      success.focus();
    }

    if (form) {
      form.addEventListener('submit', () => {
        // Shopify's hCaptcha binding can clear hidden input values after page
        // initialisation. Re-populate them before its document-level handler
        // serialises the contact form.
        populateTrackingFields();
        const button = form.querySelector('button[type="submit"]');
        if (button) button.setAttribute('aria-busy', 'true');
      });
    }

    applyFilters();
    updateComponentSelection();
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll('[data-modullo-root]').forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
